import { cardRef, cellTarget, defineGameCard, onResolve, planningTargets, targetStep, } from '../authoring/index.js';
import { applyThorns, plannedCellId } from './plant-helpers.js';
/**
 * Колючие семена: Колючки 2 на пустую вражескую ячейку. При срабатывании
 * Растение владельца напротив получает Рост. Розыгрыш —
 * перетаскивание или выбор заклинания и нажатие прямо на ячейку. Занятая к
 * resolution ячейка авторитетно физзлит весь план (all_or_nothing).
 */
export const ThornSeedsCard = defineGameCard({
    id: 'thorn_seeds',
    gameplay: {
        type: 'SPELL',
        cost: 1,
        planning: planningTargets([
            targetStep('cell', cellTarget({
                side: 'enemy',
                occupancy: 'empty',
                cardinality: { min: 1, max: 1 },
            })),
        ]),
    },
    presentation: {
        name: 'Колючие семена',
        description: 'Наложите Колючки 2 на пустую вражескую ячейку. Когда они сработают, ваше Растение напротив этой ячейки получает 1 Рост, если оно осталось на поле.',
        glyph: {
            colors: ['#10213A', '#3F434C', '#916349', '#A57255', '#A47154'],
            rows: [
                '....................',
                '....................',
                '.........12.........',
                '.........12.........',
                '.........12.........',
                '........1121........',
                '........1122........',
                '........1122........',
                '.......111222.......',
                '.......111221.......',
                '...12..111221.......',
                '...12..111221...12..',
                '...12.11112221..12..',
                '.1112111111221.112..',
                '1111221111122111121.',
                '13111141111114111121',
                '13311411111144311131',
                '13345144554544434331',
                '13333344433333353331',
                '11111111111111111111',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('plant_thorns'), cardRef('plant_growth')],
    abilities: [
        onResolve((ctx) => {
            const cellId = plannedCellId(ctx, 'cell');
            if (ctx.self === undefined || cellId === undefined)
                return;
            const cell = ctx.q.cell(cellId);
            if (cell === null || cell.occupantId !== null)
                return;
            applyThorns(ctx, cellId, 2, ctx.self.controllerId, { growthRewards: 1 });
        }),
    ],
    ui: {
        mechanics: ['thorns', 'growth'],
        planning: { steps: { cell: { label: 'Выберите пустую вражескую ячейку' } } },
    },
});
//# sourceMappingURL=thorn_seeds.js.map